export const PRICING_KEYS = [
  "audio_input",
  "audio_input_cached",
  "audio_output",
  "text_input",
  "text_input_cached",
  "text_output",
];

export const PRICING_LABELS = {
  audio_input: "Audio in ingresso",
  audio_input_cached: "Audio in ingresso (cache)",
  audio_output: "Audio in uscita",
  text_input: "Testo in ingresso",
  text_input_cached: "Testo in ingresso (cache)",
  text_output: "Testo in uscita",
};

// Token audio Realtime: 1 token ogni 100 ms di voce utente, 1 ogni 50 ms di voce assistente
export const USER_AUDIO_TOKENS_PER_SECOND = 10;
export const ASSISTANT_AUDIO_TOKENS_PER_SECOND = 20;

const count = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

export function emptyUsage() {
  return Object.fromEntries(PRICING_KEYS.map((k) => [k, 0]));
}

/** Stessa logica di parse_realtime_usage nel backend. */
export function parseRealtimeUsage(usage) {
  if (!usage || typeof usage !== "object") return emptyUsage();
  const inp = usage.input_token_details || {};
  const out = usage.output_token_details || {};
  const inText = count(inp.text_tokens);
  const inAudio = count(inp.audio_tokens);
  const cachedTotal = count(inp.cached_tokens);
  const cachedDetails = inp.cached_tokens_details;
  let cachedText;
  let cachedAudio;
  if (cachedDetails && typeof cachedDetails === "object" && Object.keys(cachedDetails).length) {
    cachedText = Math.min(count(cachedDetails.text_tokens), inText);
    cachedAudio = Math.min(count(cachedDetails.audio_tokens), inAudio);
  } else {
    cachedText = Math.min(cachedTotal, inText);
    cachedAudio = Math.min(Math.max(cachedTotal - cachedText, 0), inAudio);
  }
  return {
    audio_input: inAudio - cachedAudio,
    audio_input_cached: cachedAudio,
    audio_output: count(out.audio_tokens),
    text_input: inText - cachedText,
    text_input_cached: cachedText,
    text_output: count(out.text_tokens),
  };
}

export function addUsage(a, b) {
  const sum = emptyUsage();
  PRICING_KEYS.forEach((k) => {
    sum[k] = (a?.[k] || 0) + (b?.[k] || 0);
  });
  return sum;
}

export function costBreakdown(pricing, usage) {
  const rates = pricing || {};
  return Object.fromEntries(
    PRICING_KEYS.map((k) => [k, ((usage?.[k] || 0) * (Number(rates[k]) || 0)) / 1_000_000])
  );
}

export function costTotal(pricing, usage) {
  return Object.values(costBreakdown(pricing, usage)).reduce((s, v) => s + v, 0);
}

export function formatUsd(value, digits = 4) {
  const n = Number(value) || 0;
  return `$${n.toLocaleString("it-IT", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}
